// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.episodes-groups-tabs--desktop-view {
  display: none;
}
@media (min-width: 768px) {
  .episodes-groups-tabs--desktop-view {
    display: block;
  }
}
.episodes-groups-tabs--mobile-view {
  display: block;
}
@media (min-width: 768px) {
  .episodes-groups-tabs--mobile-view {
    display: none;
  }
}
.episodes-groups-tabs .ant-tabs-nav {
  position: sticky;
  top: calc(var(--navbar-height-player-page-mobile) + 10px);
  z-index: 1;
  background: white;
  margin-bottom: 30px !important;
}
.episodes-groups-tabs .ant-tabs-nav::after {
  content: "";
  position: absolute;
  width: 100%;
  left: 0;
  top: -20px;
  height: 20px;
  background: white;
}
.episodes-groups-tabs .ant-tabs-nav::before {
  content: "";
  position: absolute;
  width: calc(100% + 40px);
  left: -20px;
  top: -20px;
  height: calc(100% + 20px);
  background: white;
  z-index: 0;
}
.episodes-groups-tabs__selection-card-cover {
  padding-bottom: 56.25%;
  background-size: cover;
  background-color: #efefef;
  border-radius: var(--default-border-radius) var(--default-border-radius) 0px 0px;
}
.episodes-groups-tabs__column-title {
  color: var(--sections-title-color) !important;
  margin: 0 !important;
  padding: 20px;
  background-color: var(--agenda-bg-color);
  z-index: 1;
  position: sticky;
  top: calc(var(--navbar-height-player-page-mobile));
  border-bottom: 1px solid var(--default-border-color);
  margin-bottom: 30px !important;
}
@media (min-width: 1200px) {
  .episodes-groups-tabs__column-title {
    top: calc(var(--navbar-height-player-page-desktop));
  }
}
.episodes-groups-tabs__column-title::before {
  content: "";
  position: absolute;
  left: -15px;
  top: 0;
  background-color: white;
  height: 100%;
  width: 15px;
}
.episodes-groups-tabs__column-title::after {
  content: "";
  position: absolute;
  right: -15px;
  top: 0;
  background-color: white;
  height: 100%;
  width: 15px;
}`, "",{"version":3,"sources":["webpack://./src/components/functional/EpisodesGroupsTabs/EpisodesGroupsTabs.scss"],"names":[],"mappings":"AAGI;EACI,aAAA;AAFR;AAIQ;EAHJ;IAIQ,cAAA;EADV;AACF;AAII;EACI,cAAA;AAFR;AAIQ;EAHJ;IAIQ,aAAA;EADV;AACF;AAII;EACI,gBAAA;EACA,yDAAA;EACA,UAAA;EACA,iBAAA;EACA,8BAAA;AAFR;AAIQ;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,iBAAA;AAFZ;AAKQ;EACI,WAAA;EACA,kBAAA;EACA,wBAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;EACA,iBAAA;EACA,UAAA;AAHZ;AAOI;EACI,sBAAA;EACA,sBAAA;EACA,yBAAA;EACA,gFAAA;AALR;AAQI;EACI,6CAAA;EACA,oBAAA;EACA,aAAA;EACA,wCAAA;EACA,UAAA;EACA,gBAAA;EACA,kDAAA;EACA,oDAAA;EACA,8BAAA;AANR;AAQQ;EAXJ;IAYQ,mDAAA;EALV;AACF;AAOQ;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;AALZ;AAQQ;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,MAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;AANZ","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
